import React, { useState } from 'react'
import AddNewDevelopmentHistory from './AddNewDevelopmentHistory';

const DevelopmentHistory = ({ data, setIsRecordSaved, patientID, ...props }) => {

  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenDevelopmentHistory, setIsOpenDevelopmentHistory] = useState(false);
  const [developmentHistoryData, setDevelopmentHistoryData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }


  const AddDevelopmentHistory = (item) => {
    if(!isViewAllowed) return;
    setDevelopmentHistoryData(item)
    setIsOpenDevelopmentHistory(prev => !prev);
  }
  const CloseDevelopmentHistory = () => {
    setIsOpenDevelopmentHistory(false)
  }

  let PopupScreen = "";
  if (isOpenDevelopmentHistory) {
    PopupScreen = <AddNewDevelopmentHistory isOpenDevelopmentHistory={isOpenDevelopmentHistory} developmentHistoryData={developmentHistoryData} setDevelopmentHistoryData={setDevelopmentHistoryData} setIsRecordSaved={setIsRecordSaved} onClose={CloseDevelopmentHistory} patientID={patientID}// onDeleteDevelopmentHistory={DeleteDevelopmentHistory} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className=''>
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
          <p className='cursor-pointer user-select-none heading' onClick={handleToggleExpand}>Development History</p>
          <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddDevelopmentHistory({ PatientHistoryID: null })}>
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          {expandItems &&
          (data?.length > 0 ?
            data.map(item => (
              <div className='ar-dot'>
                <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddDevelopmentHistory(item)}>{item.Notes}</p>
              </div>
            )) :
            <p className="text C9-light-clr fst-italic">No development history recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default DevelopmentHistory